module.exports = __webpack_public_path__ + "img/soft-joints.f0509ef0.svg";